import { useLocation } from "react-router-dom";
import "./Navbar.css";
import NavbarItem from "./NavbarItem";

const navItems = [
  // { name: "Home", path: "/" },
  { name: "Tickets", path: "https://linktr.ee/PomonaPark", isExternal: true },
  // { name: "Socials", path: "/socials" },
  // { name: "Music", path: "/music" },
  {
    name: "Merch",
    path: "https://pomonapark.myshopify.com/",
    isExternal: true,
  },
  {
    name: "Mailing List",
    path: "https://mailchi.mp/ee72f270a454/band-email-list-landing-page",
    isExternal: true,
  },
];

function Navbar() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <div className="navbar">
        <div className="nav-items">
          {navItems.map((navItem) => (
            <NavbarItem
              name={navItem.name}
              path={navItem.path}
              isSelected={currentPath === navItem.path}
              isExternal={navItem.isExternal}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export default Navbar;
